module.exports = __webpack_public_path__ + "img/item5.184606e4.png";